import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0zm0 16.8c-4.099 0-7.461-3.18-7.77-7.2H3V8.4H1.23c.13-1.7.804-3.247 1.853-4.469l1.25 1.25.849-.848-1.25-1.251a7.76 7.76 0 0 1 10.136.001l-1.25 1.251.849.848 1.25-1.25A7.76 7.76 0 0 1 16.77 8.4H15v1.2h1.77c-.309 4.02-3.671 7.2-7.77 7.2zm.6-9.698V3H8.4v4.102A1.993 1.993 0 0 0 9 11a1.993 1.993 0 1 0 .6-3.898zM9 9.8a.801.801 0 0 1 0-1.6.801.801 0 0 1 0 1.6z" />
  </svg>
);

export default SvgComponent;
